<template>
  <p-form-element class="p-time-field">
    <p-text-field
      ref="textField"
      :value="display"
      v-bind="$props"
      :color="computedColor"
      v-on="{
        ...$listeners,
        input: onInput,
        blur: onBlur,
        focus: onFocus,
      }"
    ></p-text-field>
  </p-form-element>
</template>

<script lang="ts">
  import PTextField from '../p-text-field/p-text-field.vue';
  import interactable from '../../mixins/interactable/interactable';
  import colorable from '../../mixins/colorable/colorable';
  import clearable from '../../mixins/clearable/clearable';
  import mixins from '../../mixins';
  import pFormElement from '../p-form/p-form-element.vue';

  export default mixins(interactable, colorable, clearable).extend({
    components: { pFormElement },
    props: {
      ...((new PTextField()).$options.props),
      value: { type: String, default: undefined },
      // Label is not imported from text-field for some reason
      label: { type: String, default: '' },
      color: { type: String, default: undefined },
      contextIcon: { type: String, default: 'schedule' },
    },
    data: () => ({
      isValid: true,
      innerValue: undefined as string | undefined,
      display: undefined as string | undefined,
      // better parsing in strict mode
      validTimeFormats: ['HH:mm:ss',
                         'H:mm:ss',
                         'H:m:ss',
                         'H:m:s',
                         'HH:mm:s',
                         'HH:m:ss',
                         'H:m:ss',
                         'HH:m:s',
                         'H:mm:s',

                         'H:m:s:SSS',
                         'H:m:s:SS',
                         'H:m:s.SSS',
                         'H:m:s.SS',
                         'H:m:s,SSS',
                         'H:m:s,SS',

                         'H:m:ss:SSS',
                         'H:m:ss:SS',
                         'H:m:ss.SSS',
                         'H:m:ss.SS',
                         'H:m:ss,SSS',
                         'H:m:ss,SS',

                         'HH:mm:s:SSS',
                         'HH:mm:s:SS',
                         'HH:mm:s.SSS',
                         'HH:mm:s.SS',
                         'HH:mm:s,SSS',
                         'HH:mm:s,SS',

                         'H:mm:ss:SSS',
                         'H:mm:ss:SS',
                         'H:mm:ss.SSS',
                         'H:mm:ss.SS',
                         'H:mm:ss,SSS',
                         'H:mm:ss,SS',
                         'HH:m:ss:SSS',
                         'HH:m:ss:SS',
                         'HH:m:ss.SSS',
                         'HH:m:ss.SS',
                         'HH:m:ss,SSS',
                         'HH:m:ss,SS',

                         'h:m:s:SSS',
                         'h:m:s:SS',
                         'h:m:s.SSS',
                         'h:m:s.SS',
                         'h:m:s,SSS',
                         'h:m:s,SS',

                         'h:m:ss:SSS',
                         'h:m:ss:SS',
                         'h:m:ss.SSS',
                         'h:m:ss.SS',
                         'h:m:ss,SSS',
                         'h:m:ss,SS',

                         'hh:mm:s:SSS',
                         'hh:mm:s:SS',
                         'hh:mm:s.SSS',
                         'hh:mm:s.SS',
                         'hh:mm:s,SSS',
                         'hh:mm:s,SS',

                         'h:mm:ss:SSS',
                         'h:mm:ss:SS',
                         'h:mm:ss.SSS',
                         'h:mm:ss.SS',
                         'h:mm:ss,SSS',
                         'h:mm:ss,SS',
                         'hh:m:ss:SSS',
                         'hh:m:ss:SS',
                         'hh:m:ss.SSS',
                         'hh:m:ss.SS',
                         'hh:m:ss,SSS',
                         'hh:m:ss,SS',
                         'ha',
                         'hha',
                         'h a',
                         'hh a',
                         'hh:mm:ssa',
                         'h:mm:ssa',
                         'hh:mm:ss a',
                         'h:mm:ss a',
                         'hh:mm:ss A',
                         'h:mm:ss A',
                         'hh:mm:ssA',
                         'h:mm:ssA',
                         'h:mm:ssa',
                         'h:m:ssa',
                         'h:m:sa',
                         'hh:mm:sa',
                         'hh:m:ssa',
                         'h:m:ssa',
                         'hh:m:sa',
                         'h:mm:sa',
                         'h:mm:ssA',
                         'h:m:ssA',
                         'h:m:sA',
                         'hh:mm:sA',
                         'hh:m:ssA',
                         'h:m:ssA',
                         'hh:m:sA',
                         'h:mm:sA',
                         'h:mm:ss a',
                         'h:m:ss a',
                         'h:m:s a',
                         'hh:mm:s a',
                         'hh:m:ss a',
                         'h:m:ss a',
                         'hh:m:s a',
                         'h:mm:s a',
                         'h:mm:ss A',
                         'h:m:ss A',
                         'h:m:s A',
                         'hh:mm:s A',
                         'hh:m:ss A',
                         'h:m:ss A',
                         'hh:m:s A',
                         'h:mm:s A',
                         'H',
                         'HH',
                         'hhA',
                         'hA',
                         'h A',
                         'hh A',
                         'hh:mm a',
                         'h:mm a',
                         'h:mma',
                         'hh:mma',
                         'hh:mm A',
                         'h:mm A',
                         'h:mmA',
                         'hh:mmA',
                         'hh:mma',
                         'h:ma',
                         'hh:ma',
                         'h:mma',
                         'hh:mmA',
                         'h:mA',
                         'hh:mA',
                         'h:mmA',
                         'hh:mm A',
                         'h:m A',
                         'hh:m A',
                         'h:mm A',
                         'hh:mm a',
                         'h:m a',
                         'hh:m a',
                         'h:mm a',
                         'HH:mm',
                         'H:mm',
                         'H:m',
                         'HH:m',
                         'HH:mm:ssZ',
                         'H:mm:ssZ',
      ],
    }),
    computed: {
      computedColor(): string {
        // TODO: When validation framework is available set the error there instead of changing the color like this
        return this.isValid ? this.color : 'error';
      },
    },
    watch: {
      value: {
        immediate: true,
        handler(newValue: string) {
          this.onValueChange(newValue);
        },
      },
    },
    mounted() {
    },
    methods: {
      onValueChange(value: string) {
        if (!value) {
          this.display = '';
        } else {
          const timeObj = this.$date(value, this.validTimeFormats);
          // Time parsing has a bug, this is the only way it would work for milliseconds :(
          // TODO: Find a better way
          const timeObjLoose = this.$date(`2018-04-04T${value}Z`);
          if (timeObjLoose.millisecond() > 0) {
            this.display = timeObj.format('HH:mm:ss.') + timeObjLoose.format('SSS');
          } else {
            this.display = timeObj.format('HH:mm:ss');
          }
        }
      },
      onFocus() {
        this.onInput(this.display as string);
      },
      onBlur() {
        this.$emit('input', this.innerValue);
      },
      onInput(inputValue: string) {
        this.$set(this, 'display', inputValue);
        if (inputValue === '' || inputValue === undefined) {
          this.isValid = true;
          this.innerValue = undefined;
          return;
        }
        const timeObj = this.$date(inputValue.trim(), this.validTimeFormats, true);
        if (timeObj.isValid()) {
          this.isValid = true;
          if (timeObj.millisecond() > 0) {
            this.innerValue = timeObj.format('HH:mm:ss.SSS');
          } else {
            this.innerValue = timeObj.format('HH:mm:ss');
          }
        } else {
          this.innerValue = undefined;
          this.isValid = false;
        }
      },
    },
  });
</script>
